import * as React from 'react';
import { SVGProps } from 'react';

const IconSendMessageSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1.725 1.055a.5.5 0 0 0-.688.633l1.529 3.82L6.504 6l-3.938.492-1.529 3.82a.5.5 0 0 0 .688.633l8.999-4.498a.5.5 0 0 0 0-.894L1.725 1.055Z" />
  </svg>
);
export default IconSendMessageSizeXs;
